module.exports = __webpack_public_path__ + "img/whatsapp-griss-logo-16x16.e3de6831.svg";